import { render, staticRenderFns } from "./sidebar-item.vue?vue&type=template&id=48fb4c44&scoped=true&"
import script from "./sidebar-item.vue?vue&type=script&lang=js&"
export * from "./sidebar-item.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-item.vue?vue&type=style&index=0&id=48fb4c44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fb4c44",
  null
  
)

export default component.exports